import { createFileRoute, notFound, stripSearchParams } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { DeviceInsightsMissionsPage } from "@/components/DeviceInsights/DeviceInsightsMissionsPage";
import { dataTableSearchSchema, DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/device-data/missions/")({
  validateSearch: dataTableSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_DATATABLE_OPTIONS)],
  },
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.device-data-missions"),
        icon: <Icon.MISSION />,
        path: "/workspaces/$workspace_id/device-data/missions",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: DeviceInsightsMissionsPage,
});
